var map = {
	"./borrow-money-today.jpeg": 5505,
	"./loading": 2003,
	"./loading-cr": 3179,
	"./loading-cr.json": 3179,
	"./loading.json": 2003,
	"./logo.png": 3153,
	"./quidmarket.jpg": 6445,
	"./take-a-loan.jpeg": 3349,
	"./yourloantoday.png": 7536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;